import GeneralIcon from '../assets/index'

export default function Checkbox({ label, checked, defaultChecked = false, onChange, className = '', disabled = false, checkedClass = 'peer-checked:bg-purple-600' }) {
  // Support controlled (`checked` provided) and uncontrolled (`defaultChecked`) modes.
  const inputProps = typeof checked !== 'undefined' ? { checked, onChange, disabled } : { defaultChecked, onChange, disabled };

  return (
    <label className={`inline-flex items-center space-x-3 ${className}`}>
      <input type="checkbox" {...inputProps} className="sr-only peer" />

      <span className={`w-6 h-6 rounded-lg flex items-center justify-center bg-white border border-gray-200 transition-colors duration-150 peer-checked:border-transparent ${checkedClass}`}>
        <GeneralIcon
          iconName={"check"}
          alt="check"
          className="w-4 h-4 opacity-100 transform scale-75 peer-checked:opacity-100 peer-checked:scale-100 transition-all duration-150"
        />
      </span>

      <span className="text-sm select-none">{label}</span>
    </label>
  );
}
